<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="left">
            <el-input
              class="input"
              v-model="filter.name"
              style="width: 188px; margin-left: 10px"
              placeholder="此框输入关键词搜索"
              size="small"
            ></el-input>
            <div class="btn-box">
              <button class="search" @click="search">搜索</button>
              <button class="reset" @click="reset">重置</button>
            </div>
          </div>
          <div class="right">
            <div class="btn" @click="handleAddModal('add')">
              + 添加触发关键词
            </div>
          </div>
        </div>
        <el-table
          :data="list"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column type="index" label="序号" width="100" align="center">
          </el-table-column>
          <el-table-column
            prop="articleTitle"
            align="center"
            label="触发关键词"
            width="200"
          ></el-table-column>
          <el-table-column prop="linkProductId" align="center" label="关联产品">
            <div slot-scope="scope">
              <span v-for="(item, index) in scope.row.linkProduct" :key="index">
                {{ item.name }}
                <span v-if="index !== scope.row.linkProduct.length - 1"
                  >、</span
                >
              </span>
            </div>
          </el-table-column>
          <el-table-column prop="linkBrandId" align="center" label="关联品牌">
            <div slot-scope="scope">
              <span v-for="(item, index) in scope.row.linkBrand" :key="index">
                {{ item.name }}
                <span v-if="index !== scope.row.linkBrand.length - 1">、</span>
              </span>
            </div>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <div
              slot-scope="scope"
              style="display: flex;justify-content: center;"
            >
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="handleAddModal('edit', scope.row.id)"
                >
                  编辑
                </button>
              </div>
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deletePlatformArticle(scope.row.id)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :visible.sync="addKeywordVisible"
      class="dialog"
      width="800px"
      top="25vh"
    >
      <div slot="title" class="dialog-title">
        添加触发关键词
      </div>
      <el-form
        ref="form"
        class="form"
        label-width="auto"
        style="padding-left: 30px;"
      >
        <el-form-item label="标准答案" prop="classifyName" class="form-item">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="textarea"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="关联问题" prop="classifyName" class="form-item">
          <div class="problem-list">
            <div class="item" v-for="(item, index) in problemList" :key="index">
              <input class="input" type="text" v-model="item.text" />
              <i class="el-icon-delete" style="cursor: pointer;" @click="deleteProblem(index)"></i>
            </div>
          </div>
          <div class="add-category" @click="addProblem">
            + 添加关联问题
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn btn" @click="addKeywordVisible = false"
          >取 消</el-button
        >
        <el-button class="confirm-btn btn" @click="handleConfirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: ' ',
        secondTitle: ' '
      },
      list: [], // 轮播列表
      date: [],
      articleType: 3,
      categoryType: 3,
      categoryList: [],
      filter: {
        hotBrand: 0,
        brandName: '',
        classifyId: 0,
        name: ''
      },
      addKeywordVisible: false,
      problemList: [
        {text: 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX？'},
        {text: 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX？'},
      ]
    };
  },
  mounted() {
    // 获取列表
    this.getPlatformArticleList();
  },
  computed: {},
  methods: {
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getPlatformArticleList();
    },
    search(){
      this.getPlatformArticleList();
    },
    reset(){
      this.filter = {};
      this.getPlatformArticleList();
    },
    // 获取轮播列表
    getPlatformArticleList() {
      this.loading++;
      this.httpGet(this.$root.getPlatformArticleList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter,
      }).then(
        (res) => {
          this.loading--;
          this.list = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 删除
    deletePlatformArticle(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deletePlatformArticle, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getPlatformArticleList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    handleAddModal(){
      this.addKeywordVisible = true;
    },
    addProblem(){
      this.problemList.push({text: ''});
    },
    deleteProblem(index){
      this.problemList.splice(index);
    },
    handleConfirm(){

    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      .filter-box{
        flex-x();
        .left{
          flex-x(flex-start);
        }
        .btn-box{
          margin-left: 10px;
        }
      }

      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #999;
      }

      // 表格按钮
      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }

      .brand-pic {
        height: 36px;
        width: auto;
      }
    }
    .footer {
      width: 100%;
      padding: 24px;
      box-sizing: border-box;
      flex-x(flex-end);
      background: white;
    }
  }
  .problem-list{
    .item{
      height: 36px;
      border-radius: 5px;
      background: #F2F2F2;
      border: 1px solid #E8E8E8;
      padding: 0 16px;
      margin: 3px 0;
      flex-x(center);
      .input{
        flex: 1;
        height: 100%;
        background: transparent;
      }
    }
  }
  .add-category{
    // width: 80px;
    cursor: pointer;
    color: #5283FF;
    flex-x(flex-start);
    flex-shrink: 0;
  }
}
</style>
